export { default } from "ember-router-helpers/helpers/transition-to.js";
